import styled from 'styled-components';

const PremiumSection = styled.div`
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export default PremiumSection;
